var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-5 mt-5"},[_c('SelezioneMultipla',{attrs:{"rotta_back":_vm.rotta_back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }